var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimuladores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.102 14.969C11.102 14.901 11.1149 14.8341 11.1149 14.7661C11.1149 10.2343 11.1149 5.70256 11.1149 1.17077V0.968994H14V14.969H11.102Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41028 14.969V3.86182H10.2954V4.04848C10.2954 7.62572 10.2954 11.203 10.2954 14.7802C10.2954 14.8439 10.304 14.9064 10.3083 14.969H7.41028Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.73828H2.88507V6.93574C2.88507 9.55051 2.88507 12.1649 2.88507 14.779C2.88507 14.8416 2.89369 14.9052 2.898 14.9678H0V6.73828Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69171 14.968C3.69171 14.9097 3.70464 14.8504 3.70464 14.7921C3.70464 13.1333 3.70464 11.4749 3.70464 9.81684V9.63232H6.58971V14.968H3.69171Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimuladores);
export default __webpack_public_path__ + "static/media/Simuladores.781468024161bda3111f99fbda6f5347.svg";
export { ForwardRef as ReactComponent };